import styles from "./toolbox-components.module.css";
import { DeleteButton } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";

interface ToolboxDeleteButtonProps {
  onclick: () => void;
}

export const ToolboxDeleteButton = (props: ToolboxDeleteButtonProps) => {
  return <DeleteButton onClick={props.onclick} />;
};
